import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';

export default {
  ...cloneDeep(baseDefaults),
  defaultTab: 'left',
  buttonOneText: 'Monthly',
  buttonTwoText: 'Yearly',
  textColor: '#fff',
  textActiveColor: '#fff',
  pillColor: 'hsla(213.98, 76.15%, 21.37%, 1)',
  pillActiveColor: 'hsla(211.02, 96.24%, 58.24%, 1)',
  width: 'fluid',
  maxWidth: {
    desktop: {
      unit: 'px',
      value: 300,
    },
  },
  contentAlignment: {
    desktop: 'center',
  },
};
